import { Box, Divider, Flex, Heading, Spacer, Text } from '@chakra-ui/react';
import { getIn } from 'formik';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';

import { ReportingGlobalRecurringDateConfigs } from '../../property/globalRecurringDate/ReportingGlobalRecurringDateConfigs';
import { RecurringDateConfigView } from '../../property/RecurringDateConfigView';
import { addPortfolioCovenantConfig } from './AddPortfolioCovenantModal';
import { PortfolioCovenantEditProperties } from './PortfolioCovenantEditProperties';
import { deletePortfolioCovenantConfig } from './PortfolioCovenantTable';
import { colors } from 'packages/common-frontend/colors';
import {
  AddTextButton,
  DeleteTextButton,
} from 'packages/common-frontend/components/IconButton';
import { useQueryParams } from 'packages/common-frontend/hooks/useQueryParams';
import { WipConfig } from 'packages/creditAgreements/ui/types';
import { CalculationTerminologiesPopover } from 'packages/resources/ui/CalculationTerminologiesPopover';
import {
  PortfolioCovenantEditTab,
  SettingsFacilityPortfolioCovenantsEditTemplate,
} from 'packages/settings/ui/SettingsFacilityPortfolioCovenantsEditTemplate';
import { covenantKeyQueryParam } from 'packages/sidebar/ui/sideBarUtils';

export const PortfolioCovenantEditContainer: React.FC<{
  creditFacilityId: string;
  wipConfig: WipConfig;
}> = ({ creditFacilityId, wipConfig }) => {
  const query = useQueryParams();
  const covenantKey = query.get(covenantKeyQueryParam);

  const [selectedTab, setSelectedTab] = useState<PortfolioCovenantEditTab>(
    'properties',
  );
  const [fullPropertyKey, setFullPropertyKey] = useState<string>();

  useEffect(() => {
    const portfolioCovenantIndex = _.findIndex(
      wipConfig.formProps.values.portfolioCovenants,
      (portCov: any) => portCov?.covenantKey === covenantKey,
    );
    setFullPropertyKey(`portfolioCovenants[${portfolioCovenantIndex}]`);
  }, [covenantKey, wipConfig.formProps.values.portfolioCovenants]);

  if (!covenantKey || !fullPropertyKey) {
    return (
      <>
        Please select a portfolio covenant to edit.. add redirect link here to
        all covenants configuration route or main settings route
      </>
    );
  }
  const portfolioCovenant = getIn(wipConfig.formProps.values, fullPropertyKey);

  return (
    <SettingsFacilityPortfolioCovenantsEditTemplate
      creditFacilityId={creditFacilityId}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
    >
      {selectedTab === 'properties' && (
        <Box>
          <Box mb="32px">
            <Heading as="h3" fontSize="20px" fontWeight={600} mb="24px">
              Properties
            </Heading>
            <PortfolioCovenantEditProperties
              fullPropertyKey={fullPropertyKey}
              wipConfig={wipConfig}
            />
          </Box>
          <Divider />
          {portfolioCovenant._config_ &&
          wipConfig.isMutateAllowed(fullPropertyKey) ? (
            <>
              <Flex alignItems="center" mt="32px">
                <Heading as="h3" fontSize="20px" fontWeight={600} mb="32px">
                  Configurations
                </Heading>
                <Spacer />
                <DeleteTextButton
                  ariaLabel="delete config"
                  label="Delete Configuration"
                  onClick={() => {
                    deletePortfolioCovenantConfig(wipConfig, fullPropertyKey);
                  }}
                />
              </Flex>

              <Box mb="64px">
                <Flex alignItems="center" mb="16px">
                  <Heading as="h3" fontSize="20px" fontWeight={600} mr="8px">
                    Trigger Date
                  </Heading>
                  <CalculationTerminologiesPopover termKeyLabel="triggerDate" />
                </Flex>

                <Text color={colors.black[70]} mb="16px">
                  {`All 'Trigger Date' references in this Portfolio Covenant will
                point to this.`}
                </Text>
                <RecurringDateConfigView
                  recurringDateConfig={portfolioCovenant._config_.triggerDates}
                  wipConfig={wipConfig}
                  fullPropertyKey={`${fullPropertyKey}._config_.triggerDates`}
                  displayName="Trigger Dates"
                  displayStyle="humanReadableString"
                />
              </Box>
              <Box mb="64px">
                <ReportingGlobalRecurringDateConfigs
                  wipConfig={wipConfig}
                  globalRecurringDateConfigs={
                    portfolioCovenant._config_.globalRecurringDateConfigs
                  }
                  basePropertyKey={`${fullPropertyKey}._config_.globalRecurringDateConfigs`}
                  source="portCovs"
                />
              </Box>
            </>
          ) : (
            <Box mt="32px">
              {wipConfig?.isMutateAllowed(fullPropertyKey) ? (
                <Flex alignItems="center" mt="32px">
                  <Heading as="h3" fontSize="20px" fontWeight={600} mb="32px">
                    Configurations
                  </Heading>
                  <Spacer />
                  <AddTextButton
                    ariaLabel="add config"
                    label="Add Configuration"
                    onClick={() => {
                      addPortfolioCovenantConfig(wipConfig, fullPropertyKey);
                    }}
                  />
                </Flex>
              ) : (
                <Text>No Configuration Exists</Text>
              )}
            </Box>
          )}
        </Box>
      )}
      {selectedTab !== 'properties' && <>Tab: {selectedTab}</>}
    </SettingsFacilityPortfolioCovenantsEditTemplate>
  );
};
